export function relativeTime(input: string | number | null, opts: { terse?: boolean } = {}): string {
  if (input === null) return 'never'
  const t = typeof input === 'string' ? new Date(input).getTime() : input
  const diff = Date.now() - t
  if (opts.terse) {
    if (diff < 60_000) return `${Math.floor(diff / 1000)}s ago`
    if (diff < 3600_000) return `${Math.floor(diff / 60_000)}m ago`
    if (diff < 86400_000) return `${Math.floor(diff / 3600_000)}h ago`
    return `${Math.floor(diff / 86400_000)}d ago`
  }
  if (diff < 60_000) return 'just now'
  if (diff < 3600_000) return `${Math.floor(diff / 60_000)} min ago`
  if (diff < 86400_000) return `${Math.floor(diff / 3600_000)} hr ago`
  return `${Math.floor(diff / 86400_000)}d ago`
}
